import { frontendURL } from '../../../../helper/URLHelper';

export const routes = [
    'home',
    'inbox_dashboard',
    'inbox_conversation',
    'conversation_through_inbox',
    'notifications_dashboard',
    'label_conversations',
    'conversations_through_label',
    'product_label_conversations',
    'conversations_through_product_label',
    'topic_label_conversations',
    'conversations_through_topic_label',
    'concurrent_label_conversations',
    'conversations_through_concurrent_label',
    'team_conversations',
    'conversations_through_team',
    'conversation_mentions',
    'conversation_through_mentions',
    'conversation_participating',
    'conversation_through_participating',
    'folder_conversations',
    'conversations_through_folders',
    'conversation_unattended',
    'conversation_through_unattended',
    'conversation_unread',
    'conversation_through_unread',
    'conversation_last_message_client',
    'conversation_through_last_message_client'
];

const conversations = accountId => ({
  parentNav: 'conversations',
  routes,
  menuItems: [
    {
      icon: 'chat',
      label: 'ALL_CONVERSATIONS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home',
    },
    {
      icon: 'mention',
      label: 'MENTIONED_CONVERSATIONS',
      key: 'conversation_mentions',
      toState: frontendURL(`accounts/${accountId}/mentions/conversations`),
      toStateName: 'conversation_mentions',
    },
    {
      icon: 'people-error',
      label: 'UNATTENDED_CONVERSATIONS',
      key: 'conversation_unattended',
      toState: frontendURL(`accounts/${accountId}/unattended/conversations`),
      toStateName: 'conversation_unattended',
    },
    {
      icon: 'mail-unread',
      label: 'UNREAD_CONVERSATIONS',
      key: 'conversation_unread',
      toState: frontendURL(`accounts/${accountId}/unread/conversations`),
      toStateName: 'conversation_unread',
    },
    {
      icon: 'mail-inbox',
      label: 'LAST_MESSAGE_CLIENT_CONVERSATIONS',
      key: 'conversation_last_message_client',
      toState: frontendURL(`accounts/${accountId}/lasted/conversations`),
      toStateName: 'conversation_last_message_client',
    }
  ],
});

export default conversations;
